import React, { useState, useEffect } from "react";

const PincodeDropdown = ({ 
  countryName,
  stateName,
  cityName,
  value, 
  onChange, 
  placeholder = "Select Pincode",
  className = "",
  required = false,
  id = "pincode",
  name = "pincode"
}) => {
  const [pincodes, setPincodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (countryName && stateName && cityName) {
      fetchPincodes(countryName, stateName, cityName);
    } else {
      setPincodes([]);
    }
  }, [countryName, stateName, cityName]);

  const fetchPincodes = async (country, state, city) => {
    try {
      setLoading(true);
      setError(null);
      
      // For India, we can use India Post API or other pincode services
      // For other countries, we would need different APIs
      
      // Since there's no free comprehensive API for pincodes/zipcodes by city,
      // we're keeping this as a manual input field
      // 
      // Possible paid/limited APIs:
      // - India: https://api.postalpincode.in/postoffice/{city}
      // - US: https://www.zipcodeapi.com/
      // - Global: https://api.geonames.org/ (requires registration)
      
      // Optional: Try India Post API for Indian cities
      if (country === 'India' && city) {
        try {
          const indiaResponse = await fetch(`https://api.postalpincode.in/postoffice/${encodeURIComponent(city)}`);
          const indiaData = await indiaResponse.json();
          
          if (indiaData && indiaData[0]?.Status === 'Success' && indiaData[0]?.PostOffice) {
            const uniquePincodes = [...new Set(indiaData[0].PostOffice.map(po => po.Pincode))];
            setPincodes(uniquePincodes.map(pin => ({ code: pin })));
            return;
          }
        } catch (indiaErr) {
          console.log('India Post API not available:', indiaErr);
        }
      }
      
      setPincodes([]);
      
    } catch (err) {
      console.error('Error fetching pincodes:', err);
      setError(null); // Don't show error, just allow manual input
      setPincodes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  // If we have pincodes, show dropdown; otherwise show text input
  if (pincodes.length > 0) {
    return (
      <select
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        className={className}
        required={required}
        disabled={loading}
        style={{ 
          height: '36px',
          padding: '0 8px',
          lineHeight: '36px'
        }}
      >
        <option value="">{placeholder}</option>
        {pincodes.map((pincode, index) => (
          <option key={index} value={pincode.code} style={{ padding: '10px 8px', lineHeight: '1.5' }}>
            {pincode.code}
          </option>
        ))}
      </select>
    );
  }

  // Return as text input for manual entry
  return (
    <input
      type="text"
      id={id}
      name={name}
      value={value}
      onChange={handleChange}
      placeholder={loading ? "Loading..." : placeholder}
      className={className}
      required={required}
      disabled={!countryName || !stateName || !cityName || loading}
    />
  );
};

export default PincodeDropdown;
